<template>
	<Container>
		<TopBar/>
		<p class="title">考核题目</p>
		<div class="qs-box">
			<template v-for='(q,index) in subjects.Questions'>
				<div class="qs" v-if='q.QuestionType == 1'>
					<p class="serial-no">- 第{{index + 1}}题 - </p>
					<p class="topic">[单选题]{{q.Title}}</p>
					<div class="options">
						<RadioGroup  vertical size='large' v-model='q.select'>
							<Radio v-for='option in q.Answers' :label="option.Id" class='radio'>
					            <span class="option-title">&nbsp;&nbsp;{{option.Title}}</span>
					        </Radio>
						</RadioGroup>
					</div>
				</div>
				<div class="qs" v-else>
					<p class="serial-no">- 第{{index + 1}}题 - </p>
					<p class="topic">[多选题]{{q.Title}}</p>
					<div class="options">
						<CheckboxGroup  vertical size='large' v-model='q.select'>
							<Checkbox v-for='option in q.Answers' :label="option.Id" class='radio'>
					            <span class="option-title">&nbsp;&nbsp;{{option.Title}}</span>
					        </Checkbox>
						</CheckboxGroup>
					</div>
				</div>
			</template>
		</div>
		<div class="button-primary button" @click='handIn'><span>提交</span></div>
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters,
	} from 'vuex'
	export default {
		data() {
			return {
				subjects:{},
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			TopBar,
		},
		computed: {
			...mapState({
			}),
			...mapGetters(['getVipNo']),
		},
		methods: {
			...mapActions([
				'getELearnExamAction',
				'submitExamAction',
			]),
			async initData(){
				let ec = this.$route.query?.code
				let response = await this.getELearnExamAction({
					ec
				})
				if (response?.length) {
					let subjects = response[0]
					subjects.Questions.forEach(item=>item.QuestionType == 1 ? item.select = 0 : item.select = [])
					this.subjects = subjects
				} else {
					this.$Modal.warning({
						title:'提示',
						content:'考核题目未获取到',
						onOk:()=>{
							this.$router.go(-1)
						}
					})
				}
			},
			handIn(){
				this.$Modal.confirm({
					title:'确认',
					content:'确认提交？',
					loading:true,
					onOk:async ()=>{
						let response = await this.submit()
						this.$Modal.remove()
						await this.sleep(300)
						if (response?.Flag == 2) {
							this.$Modal.success({
								title:'提交成功',
								content:'提交成功，点击前往查看成绩',
								onOk:()=>{
									this.$Modal.remove()
									this.routerPush({
										path:'/train/result',
										query:{
											code:this.subjects.RecordCode,
											ec:this.subjects.Code
										},
										params:{
											subjects:this.subjects,
											result:response.RecordData,
										}
									})
								}
							})
						} else {
							this.$Modal.error({
								title:'提交失败',
								content:'提交失败，请稍后重试',
							})
						}
					},
					onCancel:()=>{

					},
					cancelText:'',
					okText:'确认提交'
				})
			},
			async submit(){
				let AnswerList = this.subjects.Questions.map((item,index)=>{
					return {
						QuestionCode: item.Code,	/// 题目编号
						AnswerCode: item.QuestionType == 1 ?item.select : item.select.join(','),	// 选择的答案编号,（多选时以逗号分隔）
						AnswerOrder:item.Answers.map(item=>item.Id).join(','),
						QuestionNo:index + 1,
						Description:""	/// 描述文字，针对简单题等
					}
				})
				let params = {
					ExamCode:this.$route?.query.code,			//考试编号
					LessonCode:this.$route.query?.lessonCode,
					UserCode:this.getVipNo,			/// 答题的用户编号
					IsSubmit:1,		 /// 是否交卷0：未交卷（只是部分提交答案）  1：全部结束交卷；
					RecordCode:this.subjects.RecordCode,
					AnswerList,
				}
				console.log(params)
				let response = await this.submitExamAction(params)
				return response
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.title {
		@include fontSize($font-size-20);
		color:$theme-color;
		font-weight: bold;
		text-align: center;
		margin: 20px;
	}
	.topic {
		@include fontSize($font-size-16);
	}
	.option-title {
		@include fontSize($font-size-16);
	}
	.qs-box {
		margin:20px 10.42vw;
		.head {
			color:$theme-color;
			@include fontSize($font-size-24);
			display: flex;
			align-items: center;
			margin-bottom: 30px;
			img {
				width:30px;
				margin-right: 10px;
			}
		}
		.qs {
			color:black;
			@include fontSize($font-size-18);
			margin-bottom: 20px;
			.serial-no {
				font-weight: bold;
				margin-bottom: 10px;
			}
			.radio {
				margin: 10px 0;
				display:block;
			}
			.correct {
				span {
					color:$theme-color;
				}
			}
		}
	}
	.button {
		height:60px;
		width:20.83vw;
		min-width: 200px;
		border-radius: 60px;
		margin: 5.21vw auto 90px;
		@include fontSize($font-size-20);
	}
</style>